import { FC } from 'react'
import { getStyledPCColumn } from '../../styled-components/AboutSection.styled'
import { AboutCard } from './AboutCard.component'
const aboutOne = require('../../util/icons/about1.png')
const aboutTwo = require('../../util/icons/about2.png')
const aboutThree = require('../../util/icons/about3.png')
const aboutFour = require('../../util/icons/about4.png')

export interface PCCardHolderProps {

}

export const PCCardHolder: FC<PCCardHolderProps> = (props) => {

    const ContentWrapper = getStyledPCColumn()

    return (
        <>
            <ContentWrapper>
                <AboutCard
                    num={1}
                    title='Who we are'
                    description='You get a 2-week free trial to kick the Smarty tries. We want you to.'
                />
                <AboutCard
                    num={2}
                    title='What do we do'
                    description='We give you a free course that guides you throught the process.'
                />
            </ContentWrapper>
            <ContentWrapper>
                <AboutCard
                    num={3}
                    title='How do we help'
                    description='Use our multimedia lectures, videos, and coaching sessions.'
                />
                <AboutCard
                    num={4}
                    title='Create success story'
                    description='With access to online learning resources anyone can transform.'
                />
            </ContentWrapper>
            <ContentWrapper style={{marginTop: '5vh'}}>
                <img src={aboutOne} alt="Teepo" />
                <img src={aboutTwo} alt="Sofa" />
            </ContentWrapper>
            <ContentWrapper>
                <img src={aboutThree} alt="Chair" />
                <img src={aboutFour} alt="Hall" />
            </ContentWrapper>
        </>
    )
}